import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import '../../Assets/CSS/search.css';
import { FaSearch } from "react-icons/fa";
import Login from "../auth/login/Login";
import toast from "react-hot-toast";

const HomeSearch = ({ qparams, marginTop, setParams,isAuthenticated }) => {
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false); // State for login modal visibility  
  const [selectedCountry, setSelectedCountry] = useState(qparams ? qparams.productCountry : "");
  const [selectedCompany, setSelectedCompany] = useState(qparams ? qparams.sellerId : "");
  const [selectedCategory, setSelectedCategory] = useState(qparams ? qparams.productCategoryNames : "");
  const [searchTerm, setSearchTerm] = useState(qparams ? qparams.productName : "");
  const location = useLocation();

  const [companies, setCompanies] = useState([]); // State to store companies

  const countries = [
    { value: "AF", label: "Afghanistan" },
    { value: "AL", label: "Albania" },
    { value: "DZ", label: "Algeria" },
    { value: "AD", label: "Andorra" },
    { value: "AO", label: "Angola" },
    { value: "IN", label: "India" },
  ];

  const [categories, setCategories] = useState([])



  // Fetch the list of sellers (companies) from the API
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/user/products/sellers`
          ,{
            headers:{
              "Content-Type":"application/json",
              // "X-product-Country":productCountry,
            }
          });
       
        
        const companyData = response.data.map((seller) => ({
          userId: seller.userId,
          name: `${seller.firstName} ${seller.lastName}`, // Combine first and last name
        }));
        setCompanies(companyData); // Populate the company dropdown
      } catch (error) {
        console.error("Error fetching companies:", error);
        alert("Failed to fetch company data.");
      }
    };

    fetchCompanies();
    fetchCategories();
  }, []);

  const fetchCategories = async () =>{
     try{
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/category`,{
        headers:{
          "Content-Type":"application/json",
          // "X-product-Country":productCountry,
        }
      });

      const categoryNames = response.data.map(item => item.categoryName);
      setCategories(categoryNames)
     }
     catch (error) {
      console.error("Error fetching companies:", error);
      alert("Failed to fetch company data.");
    }
  }


  const handleSearchClick = async () => {
    
    if(!isAuthenticated){
      setShowLoginModal(true);
      return;
    }

    // Build the query parameters dynamically
    const params = {};

    if (searchTerm) {
      params.productName = searchTerm.trim(); // Add product name to the query
    }
    // const trimmedSearch = searchTerm.trim();
    // if (trimmedSearch) {
    //   params.productName = trimmedSearch;
    // }
    if (selectedCategory) {
      params.productCategoryNames = selectedCategory; // Add category to the query
    }
    if (selectedCountry) {
      params.productCountry = selectedCountry; // Add country to the query
    }
    if (selectedCompany) {
      params.sellerId = selectedCompany; // Add company userId to the query
    }
    try {
      if(Object.keys(params).length === 0){
        toast.error("Please Select or type a product to explore the products")
        return;
      }
      if (selectedCompany || selectedCategory || searchTerm) {

      
        console.log("Params before passign to Pridyct list",params);
        if(location.pathname =="/productlist"){
          setParams(params)
          window.location.reload();
        }
      
        
        navigate("/productlist", { state: { params: params } });

      } else {
        const selectedCountryLabel = countries.find((country) => country.value === selectedCountry)?.label || "Unknown";

        navigate("/companylist", { state: { selectedCountryLabel: selectedCountry } });
      }
    } catch (error) {
      console.error("Error during search:", error);
      alert("An error occurred while searching. Please try again.");
    }
  };
  const handleCloseLogin = () => setShowLoginModal(false);
   const boxShadowValue = location.pathname === "/productlist" ? '0px 0px 4px 1px #FFFFFF4D' : '0px 0px 16px 2px #FFFFFF4D';
  return (
    <div className="container  mt-3 px-5">
      <div className="row pt-2">
        <div
          className=" g-3 px-lg-2 search-row  shadow-lg d-flex flex-column flex-md-row align-items-center 
                     px-3 rounded-5 rounded-md-pill" 
          style={{ margin: "auto", 
            boxShadow: boxShadowValue,
            // boxShadow: '0px 0px 16px 2px #FFFFFF4D',
            marginTop: marginTop }}
        >

        {/* Country Dropdown */}
        <div className="col-md col-12 custom-border px-2">
          <select
            className="form-select  fs-6 shadow-none select-border"
            aria-label="Select Country"
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
          >
            <option value="">Select a Country</option>
            {countries.map((country) => (
              <option key={country.value} value={country.label}>
                {country.label}
              </option>
            ))}
          </select>
        </div>

        {/* Company Dropdown */}
        <div className="col-md col-12 custom-border px-2">
          <select
            className="form-select  fs-6 shadow-none select-border"
            aria-label="Select Company"
            value={selectedCompany || ""}
            onChange={(e) => {
              
              setSelectedCompany(e.target.value)}}

          >
            <option value="">Select a Company</option>
            {companies.map((company) => (
              <option key={company.userId} value={company.userId}>
                {company.name}
              </option>
            ))}
          </select>
        </div>

        {/* Category Dropdown */}
        <div className="col-md col-12 custom-border px-2">
          <select
            className="form-select fs-6 shadow-none  select-border  position-relative"
            aria-label="Select Category"
            value={selectedCategory || ""}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">Select a Category</option>
            {categories.map((category, index) => (
              <option key={index} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        {/* Search Input */}
        <div className="col-md col-12 d-flex px-2 search-bar align-items-center justify-content-center position-relative">
          <input
            type="text"
            className="form-control border-0 shadow-none select-border search-input "
            placeholder="Search product..."
            aria-label="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearchClick(e); // pass the event here
              }
            }}
          />
         
          {/* Search Button for Small Screens */}
        
        </div>
        <div className="col-1 search-icon" onClick={handleSearchClick}>
            <FaSearch color="#FFFFF" />
          </div>
        <div className="col-12 d-block d-md-none mt-3">
          <button className="btn search-btns w-100" onClick={handleSearchClick}>
            <FaSearch className="me-2" /> Search
          </button>
        </div>
      </div>
      </div>
              {/* Login Modal */}
                    {showLoginModal && (<Login onClose={handleCloseLogin} loginopen={showLoginModal} />
              )}
      
    </div>
  );

};

export default HomeSearch;
